import { render } from "./IndividualView.vue?vue&type=template&id=1991e140&scoped=true"
import script from "./IndividualView.vue?vue&type=script&lang=js"
export * from "./IndividualView.vue?vue&type=script&lang=js"

import "./IndividualView.vue?vue&type=style&index=0&id=1991e140&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1991e140"]])

export default __exports__